import { ActionModalHeightContext } from '@srm/ui/modal/action-height-context';
import { IBaseAction } from '@models/actions/IBaseAction';
import { IActionExecutor } from './IActionExecutor';

export const withActionModalHeight = (executor: IActionExecutor, action: IBaseAction): IActionExecutor => {
    if (action.options?.fullHeight !== true || !executor.visualElement) return executor;

    const visualElement = executor.visualElement.bind(executor);
    executor.visualElement = () => (
        <ActionModalHeightContext value={true}>{visualElement()}</ActionModalHeightContext>
    );
    return executor;
};
